export default __webpack_public_path__ + "static/og-image-5316ef8cb23040e98e1c206ba4ed5cc7.png";